import React from "react";
import styles from "./OverlayGroup.module.scss";
import OverlayGroupItem from "../OverlayGroupItem/OverlayGroupItem";

import utdanningerIcon from "../../img/Ikoner_Utdanning_small.svg";
import laerestederIcon from "../../img/Ikoner_Læresteder_small.svg";
import artikkelIcon from "../../img/Ikoner_Artikkel-intervju_small.svg";
import yrkerIcon from "../../img/Ikoner_Yrker_small.svg";
import annetIcon from "../../img/Ikoner_Oppgaver-utdanningsvalg_small.svg";
import {useDispatch, useSelector} from "react-redux";
import {ACTIVATE_MAIN_FACET} from "../../Store/Actions/ActionTypes";
import {handleSearchValueSubmit} from "../../Store/Actions/NewFilterActions";


const OverlayGroup = (props) => {
    const {title, items} = props;
    const newFilterState = useSelector(state => state.newFilterReducer);
    const dispatch = useDispatch();
    const acSearchInputValue = newFilterState.acSearchInputValue;
    let icon;

    // Only Utdanninger and Yrker should show results.
    let showResults = false;
    switch (title) {
        case "Utdanninger":
            icon = utdanningerIcon;
            showResults = true;
            break;
        case "Annet innhold":
            icon = annetIcon;
            break;
        case "Lærested":
            icon = laerestederIcon;
            break;
        case "Artikler":
            icon = artikkelIcon;
            break;
        case "Yrker":
            icon = yrkerIcon;
            showResults = true;
            break;
        case "Verktøy":
            icon = annetIcon;
            showResults = true;
            break;
        default:
            icon = null;
            break;
    }

    let itemsRendered = [];
    if (showResults) {
        for (let i = 0; i < items.length; i++) {
            if (i === 5) break; // Only the first 5 should be shown.
            itemsRendered.push(
                <OverlayGroupItem
                    key={items[i]['@id']}
                    title={items[i].title}
                    url={items[i].url}
                    type={items[i].type}
                />
            );
        }
    }

    const seeAll = <div className={styles.seeall}>Se alle ▸</div>;

    const HandleHeaderClick = (title) => {
        dispatch(handleSearchValueSubmit(acSearchInputValue));
        const payload = {
            value: title
        };
        dispatch({type: ACTIVATE_MAIN_FACET, payload: payload});
    };

    return (
        <div className={styles.wrapper}>
            <div onClick={() => HandleHeaderClick(title)} className={styles.header}>
                {icon &&
                <img className={styles.icon} src={icon} alt={title + " ikon"}/>
                }
                {/*<h2>{title} ({items.length})</h2>*/}
                <h2>{title}</h2>
                {seeAll}
            </div>
            <div className={styles.body}>
                {itemsRendered}
            </div>
        </div>
    );

};

export default OverlayGroup;
